import styled from 'styled-components/macro'

const TileList = styled('ul')`
  margin: 0 -4px;
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  width: calc(100% + 8px);
`

export default TileList
